/**
 * String helpers (avoid ReDoS-prone trailing-slash regexes — S5852).
 */
export function trimTrailingSlashes(value: string): string {
  let s = value;
  while (s.endsWith('/')) {
    s = s.slice(0, -1);
  }
  return s;
}
